import * as React from "react";

import { cn } from "@wellcheck/components/lib/cn";

// NOTE: forwardRef を噛ませている理由 (button.tsx の同種 NOTE を参照)。
// react-hook-form の register() が返す ref は uncontrolled input の DOM ノードに直接つながって
// 初めて値を収集できる。forwardRef を外すと React 18 ではこの ref が捨てられ、RHF が
// input の値を読めないまま undefined 扱いになる (実 backend + ブラウザ QA で発覚)。
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          "h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30",
          "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
          "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
